import { createMutation } from '@tanstack/svelte-query';
import { createRCU, deleteRCU, updateRCU } from '$lib/api/rcu';
import { invalidateAfterRcuUpdate } from '$lib/state/invalidation';
import { getUnitScope, resolveScope, type ScopeFn } from '$lib/queries/scope';
import type { RCURequest, RCUResponse } from '$lib/types/rcu';

export const createRcuMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<RCUResponse, Error, RCURequest>(() => ({
		mutationFn: (request) => createRCU(request),
		onSuccess: () => invalidateAfterRcuUpdate(resolveScope(scope))
	}));

export const updateRcuMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<RCUResponse, Error, { id: number; request: Partial<RCURequest> }>(() => ({
		mutationFn: ({ id, request }) => updateRCU(id, request),
		onSuccess: () => invalidateAfterRcuUpdate(resolveScope(scope))
	}));

export const deleteRcuMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<void, Error, number>(() => ({
		mutationFn: (id) => deleteRCU(id),
		onSuccess: () => invalidateAfterRcuUpdate(resolveScope(scope))
	}));
